var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7452 10.4363C15.424 10.633 15.1579 10.9079 14.9719 11.2354C14.7858 11.5629 14.6859 11.9323 14.6815 12.3089C14.6828 12.7328 14.8084 13.1471 15.0427 13.5003C15.2771 13.8535 15.6099 14.1302 16 14.2962C15.8462 14.7924 15.6186 15.2626 15.3248 15.6911C14.9045 16.2962 14.4649 16.9012 13.7962 16.9012C13.1274 16.9012 12.9554 16.5127 12.1847 16.5127C11.4331 16.5127 11.1656 16.914 10.5541 16.914C9.94265 16.914 9.51594 16.3535 9.02547 15.6656C8.37759 14.7019 8.02153 13.5718 8 12.4108C8 10.5 9.24206 9.48729 10.4649 9.48729C11.1146 9.48729 11.6561 9.91399 12.0637 9.91399C12.4522 9.91399 13.0574 9.46176 13.7962 9.46176C14.1761 9.45196 14.5525 9.53571 14.8924 9.70566C15.2323 9.8756 15.5252 10.1265 15.7452 10.4363ZM13.4459 8.65288C13.7716 8.26975 13.9559 7.78647 13.9682 7.28377C13.9687 7.2175 13.9623 7.15136 13.9491 7.08643C13.3896 7.14107 12.8723 7.40772 12.5032 7.83166C12.1743 8.19952 11.983 8.66989 11.9618 9.16284C11.962 9.22279 11.9684 9.28255 11.9809 9.34119C12.025 9.34953 12.0698 9.3538 12.1146 9.35396C12.3725 9.33344 12.6234 9.26071 12.8523 9.14019C13.0811 9.01967 13.2831 8.85387 13.4459 8.65288Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconApple);
export default __webpack_public_path__ + "static/media/icon_apple.a77886ee31a7bbe5906bd331b7b20e1d.svg";
export { ForwardRef as ReactComponent };